import { DownArrowIcon } from 'assets/icons';
import { FC, ReactNode, useState } from 'react';
import { twMerge } from 'tailwind-merge';

interface AccordionProps {
  title: ReactNode;
  children: ReactNode;
  initialOpen?: boolean;
  className?: string;
  headerRight?: ReactNode;
  ArrowClassName?: string;
  openStateHeaderStyle?: string;
  headerStyle?: string;
  iconAlignRight?: boolean;
  onOpen?: (isOpen: boolean) => void;
}

const Accordion: FC<AccordionProps> = ({
  title,
  children,
  initialOpen = false,
  className = '',
  headerRight,
  ArrowClassName = '',
  openStateHeaderStyle = '',
  headerStyle = '',
  iconAlignRight = false,
  onOpen
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(initialOpen);

  const toggleAccordion = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    onOpen?.(newIsOpen);
  };

  return (
    <div className={twMerge('w-full overflow-hidden', className)}>
      <div
        className={twMerge(
          'flex cursor-pointer items-center justify-between bg-white pb-2 text-17px font-bold',
          headerStyle,
          isOpen && openStateHeaderStyle
        )}
        onClick={toggleAccordion}
        role="button"
        aria-expanded={isOpen}>
        <div className="flex w-full items-center">
          {!iconAlignRight && (
            <DownArrowIcon
              className={`mr-2 ${ArrowClassName} h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
            />
          )}
          <div className="w-full">{title}</div>
        </div>
        {headerRight && <div>{headerRight}</div>}
        {iconAlignRight && (
          <DownArrowIcon
            className={`ml-2 ${ArrowClassName} h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          />
        )}
      </div>
      {isOpen && <div className="bg-white">{children}</div>}
    </div>
  );
};

export default Accordion;
